import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {

const { pathname } = useLocation();

useEffect(() => {

const mainContent = document.querySelector(".App");

if (mainContent) {
mainContent.scrollTo({
top: 0,
behavior: "instant"
});
}

window.scrollTo(0, 0);

}, [pathname]);

return null;
}